import { atom, useAtom } from "jotai";
import {postMessage, triggerEvent, useEventListener} from "@/common/event";
import {
    EVENT_CARD_CLOSED,
    EVENT_NOTE_CHANGED,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_OPEN_NOTE, EVENT_REFRESH_INFO,
    EVENT_REFRESH_RECENTS, KEY_ISCTRL_CMD_PRESSED, MAX_CARD_COUNT
} from "@/Const";
import global from "@/global";
import {getCardById, getCardCount} from "@model/card";
import {hasDesktopBaseLicense, hasLicense, isFreeCreateCardMode, logger} from "@/utils";
import {t} from "i18next";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import Global from "@/global";
import {isZh} from "@/language";
import {isInSingleFloatWindow} from "@/Utility";

/** 全屏展示笔记编辑器  */
export const FullScreen = atom<boolean>(isInSingleFloatWindow()?true:false);

export const pdfAtom = atom<boolean>(false);

/** 显示编辑器 */
export const ShowEditor = atom<boolean>(false);



/** 新建、编辑笔记 */
export async function openEditor(id = '',bCloseSlider:boolean=true,isShowInDraw:boolean = true,from:string ='',type:'card'|'journal'='card',annoId:any = '') {
    global.g_currentNoteType = type;
    global.g_dialogName = 'card';

    //关闭未pin的弹窗
    window.closeUnpinDialogCard();

    //判断是否是新建的card..
    let card = await getCardById(id);
    if (!card){
        //是新建card
        if (!hasLicense() && !hasDesktopBaseLicense()){
            const nCount = await getCardCount();
            if (nCount > MAX_CARD_COUNT && !isFreeCreateCardMode()){
                window.showMessageBox(t("Upgrade required"),t("YouNeedToUpgradeCreateCard"),t("Cancel"),t("Learn more"),null,()=>{
                    if (isZh()) {
                        ipcSend('open-url',import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                    }else {
                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                    }
                })
                return;
            }
        }
    }else{
        //重置下全局的这个....
        Global.g_currentNoteData = card;
        if (annoId){
            global.g_currentNoteData.annoId = annoId;
        }
    }
    if (!card){
        card = {...Global.g_currentNoteData};
    }
    sessionStorage.setItem('note-id', id);
    global.g_isDialogNoteIsDrawPage = isShowInDraw;
    global.g_dialogNoteFrom = from;
    triggerEvent('editor-show-change', true);
    //打开一个弹窗....
    window.openDialogCard(card);
    //如果右侧有打开的笔记，要关闭...
    // if (bCloseSlider){
    //     postMessage(EVENT_OPEN_NOTE)
    // }
}

/** 退出笔记界面 */
export function closeEditor(card = null) {
    global.g_dialogName = '';
    sessionStorage.removeItem('note-id');
    if (window.closePopupCardList){
        window.closePopupCardList();
    }
    //刷新最近
    setTimeout(()=>{
        postMessage(EVENT_REFRESH_RECENTS);
    },600)

    //刷新info
    setTimeout(()=>{
        postMessage(EVENT_REFRESH_INFO);
    },200)

    triggerEvent('editor-show-change', false);

    if (card){
        window.closeDialogCard(card);
    }else{
        window.closeUnpinDialogCard();
    }
}